import { Mention } from './mention';
import { CommentType } from './enums/comment-type';

export class Comment {
   id: number;
   text: string;
   createdUserFullName: string;
   createdUserId: number;
   mentions: Array<Mention>;
   createdBy?: string;
   createdDate: string;
   documentId: number;
   type: CommentType;

   constructor() {
      this.id = 0;
      this.text = '';
      this.mentions = [];
      this.createdDate = '';
      this.createdUserFullName = '';
      this.createdUserId = 0;
      this.documentId = 0;
      this.type = CommentType.User;
   }
}
